document.addEventListener("DOMContentLoaded", () => {
  // Get all input elements from .form__label.product-form__controls-group
  const inputs = document.querySelectorAll('.form__label.product-form__controls-group input');
  
  // Get all .variant-info elements from .product-variants
  const variantInfos = document.querySelectorAll('.product-variants .variant-info');
  
  // Add event listeners to each input
  inputs.forEach((input, index) => {
    input.addEventListener('change', () => {
      // Remove 'active' class from all .variant-info
      variantInfos.forEach(variant => variant.classList.remove('active'));
      
      // If this input is checked, add 'active' class to the corresponding .variant-info
      if (input.checked) {
        variantInfos[index].classList.add('active');
      }
    });
  });
  
  // Initial state - set 'active' class based on the checked input on page load
  inputs.forEach((input, index) => {
    if (input.checked) {
      variantInfos[index].classList.add('active');
    }
  });
});
